import React, { PureComponent } from 'react'
import HigherOrderField from './higher-order-field.component'

class BaseTextAreaInput extends PureComponent {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
	}

	render() {
		const {
			id,
			placeholder,
			maxLength,
			disabled,
			rows,
			value,
			onChange,
			onBlur
		} = this.props

		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<textarea
					autoCorrect="nope"
					autoComplete="nope"
					ref={this.elementRef}
					id={id}
					name={id}
					maxLength={maxLength}
					placeholder={placeholder}
					disabled={disabled}
					rows={rows}
					value={value || ''}
					onChange={onChange}
					onBlur={onBlur}
				/>
			</HigherOrderField>
		)
	}
}

export default BaseTextAreaInput
